/* eslint-disable no-console */
import React from 'react';

import {ReactComponent as CompTile} from '../../../assets/companyTile.svg';

import {LegendColors, orgKey} from './Constants/commonConstants';

const CustomNodeContent: React.FC<{data: any}> = ({data}) => {
  const styles = {
    nodeContainer: {
      minHeight: 'fit-content',
      backgroundColor: '#ffffff',
      color: '#000',
      display: 'flex',
      justifyContent: 'center',
      borderRadius: '1rem',
      border: '2px solid #e1f3d9',
      width: '100% !important',
      height: '100% !important',
      gap: '1rem'
    },
    scope_1_2: {
      minHeight: '150px',
      color: '#fef9ef',
      display: 'flex',
      justifyContent: 'center',
      borderRadius: '1rem',
      backgroundColor: LegendColors.scope1_2
    },
    allScope: {
      minHeight: '150px',
      color: '#fef9ef',
      display: 'flex',
      justifyContent: 'center',
      borderRadius: '1rem',
      backgroundColor: LegendColors.allScope
    },
    nodeDetails: {
      width: '100%',
      padding: '1rem',
      display: 'flex',
      flexDirection: 'column' as React.CSSProperties['flexDirection'],
      justifyContent: 'center'
    },
    nodeContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1rem',
      flexDirection: 'row' as React.CSSProperties['flexDirection'],
      flex: 1,
      padding: '10px'
      // marginRight: '3rem'
    },
    nodeContentI: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1rem',
      flexDirection: 'column' as React.CSSProperties['flexDirection'],
      // whiteSpace: data.children ? 'noWrap !important' : 'unset',
      whiteSpace: 'pre-line' as React.CSSProperties['whiteSpace'],
      textAlign: 'center' as React.CSSProperties['textAlign']
      // marginRight: 150
      // paddingLeft: '1rem'
    },
    nodeTeam: {
      width: '100%',
      textAlign: 'center' as React.CSSProperties['textAlign']
    },
    nodeTeamName: {
      marginBottom: '0.5rem',
      color: '#fef9ef',
      fontSize: '1.5rem'
    },
    nodeTeamMemberImg: {
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      margin: '0.2rem'
    },
    nodeImg: {
      width: '90px',
      height: '90px',
      borderRadius: '1rem',
      marginRight: '10px'
    },
    nodeInfo: {
      marginLeft: '1.5rem',
      color: '#fef9ef',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly'
    },
    nodeName: {
      paddingBottom: '0.3rem',
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginLeft: '1rem'
      // paddingLeft: '1rem'
    },
    nodeNameSub: {
      paddingBottom: '0.3rem',
      color: '#282A3A',
      // fontSize: '1.5rem',
      // fontWeight: 'bold',
      fontSize: '1.2rem',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%'
    },
    nodeRole: {
      paddingBottom: '0.5rem',
      fontSize: '1.2rem'
    },
    nodeDepartment: {
      padding: '0.5rem',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#ffcb77',
      borderRadius: '1rem',
      color: '#227c9d'
    },
    icon: {
      marginRight: '0.5rem'
    }
  };

  return (
    <>
      <div
        style={
          data.type === orgKey.scope1_2
            ? styles.scope_1_2
            : data.type === orgKey.allScope
              ? styles.allScope
              : styles.nodeContainer
        }
      >
        {data.parentId === '' && (
          <div className="orgParent">
            <CompTile className="orgIcon" />
          </div>
        )}
        <div style={styles.nodeDetails}>
          <div style={styles.nodeContent}>
            <div style={styles.nodeContentI}>
              <div
                style={
                  data.parentId === '' ? styles.nodeName : styles.nodeNameSub
                }
              >
                {data.name}
              </div>
              {data.positionName && (
                <div style={styles.nodeRole}>{data.positionName}</div>
              )}
            </div>
            {/* <div style={{flex: 1, width: '1rem', height: '1rem'}}>{''}</div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomNodeContent;
